// @flow
import * as commonActionTypes from '../GUI_COMMON/ACTIONS/commonActionTypes';
import initialState from './initialState';

export default function serverInfoReducer(state = initialState.archiverServerInfo, action) {
    
    switch (action.type) {
        case(commonActionTypes.GOT_SERVER_INFO): {  
            // this is specific to the archiver 
            // (the other initialState.serverInfo is for the COMMON device guis -- shared code there)
            return {
                initialized: true,
                name: action.name,
                version: action.version,                        // webservice version                      
                requiredDbVersion: action.requiredDbVersion,    // added by pott - 231117
                dbVersion: action.dbVersion,                    // added by pott - 231117
                demoMode: action.demoMode,                      // added by pott - 220905
                localTimeUtc: action.localTimeUtc,              // added by pott - 221117
                config: action.config,                          // added by pott - 250721
            };
        }
        
        default:
            return(state)
    }
}

